import React, { useState, useEffect } from 'react'
import { errorMap } from './BaseComponent'

export default function Tracks({ API, selectTrack, selectedTr, required, articleUUID }) {
    const [tracks, setTracks] = useState([])
  
    const getTracks = () => {
      let url = API+( articleUUID ? `/tracks?used=0&article_whitelist=${articleUUID}` : "/tracks?used=0")
  
      fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + sessionStorage.getItem('token')
          }
        })
      .then((response) => {
          return response.json()
      })
      .then((result) => {
        if (result.status.success) {
          setTracks(result.data)
        } else {
          window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error) }}), true);
        }
      }, (error) => {
        console.log(error)
      })
    }
  
    useEffect(() => {
      getTracks()
      // eslint-disable-next-line
    }, [])
    
    return (
      <select value={ selectedTr?.uuid } onChange={ (e) => { selectTrack(e.target.value) } } required={ required ? true : false }>
        <option value="">Brak pliku audio</option>
        { tracks.map((item, i) => {
          return (
            <option key={ i } value={ item.uuid }>{ item.title }</option>
          )
        }) }
      </select>
    )
  }